import { useEffect, useRef } from "react";
import { Delete, Loader2, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

const Key = ({ onClick, testid, children, className, disabled }) => (
  <button type="button" onClick={onClick} disabled={disabled} data-testid={testid}
    className={cn("h-14 rounded-2xl border border-white/10 bg-white/[0.045] text-xl font-semibold text-white tabular-nums transition-[background-color,transform] duration-150 hover:bg-white/10 active:scale-95 active:bg-white/15 disabled:opacity-40", className)}>
    {children}
  </button>
);

// 4 haneli tuş takımı: ekranda hazır açık + fiziksel klavyeden rakam/Backspace/Enter yakalanır
export function PinPad({ value, onChange, onComplete, prefix, submitTestid, loading, shakeKey = 0, length = 4, active = true }) {
  const ref = useRef({ value, loading });
  ref.current = { value, loading };
  const press = (n) => {
    const v = ref.current.value;
    if (ref.current.loading || v.length >= length) return;
    const next = v + String(n);
    onChange(next);
    if (next.length === length) onComplete(next);
  };
  const back = () => { if (!ref.current.loading) onChange(ref.current.value.slice(0, -1)); };
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => {
      if (e.target && ["INPUT", "TEXTAREA"].includes(e.target.tagName)) return;
      if (/^[0-9]$/.test(e.key)) { e.preventDefault(); press(e.key); }
      else if (e.key === "Backspace") { e.preventDefault(); back(); }
      else if (e.key === "Enter" && ref.current.value.length === length) { e.preventDefault(); onComplete(ref.current.value); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });
  return (
    <div className="space-y-6">
      <div key={shakeKey} className={cn("flex justify-center gap-4", shakeKey > 0 && "ge-shake")} data-testid={`${prefix}-dots`}>
        {Array.from({ length }).map((_, i) => (
          <span key={i} className={cn("h-4 w-4 rounded-full border-2 transition-all duration-200",
            i < value.length ? "bg-[#F55913] border-[#F55913] scale-110 shadow-[0_0_16px_rgba(245,89,19,.75)]" : "border-white/30")} />
        ))}
      </div>
      <input type="hidden" value={value} readOnly data-testid={`${prefix}-value`} />
      <div className="grid grid-cols-3 gap-2.5">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => <Key key={n} onClick={() => press(n)} testid={`${prefix}-key-${n}`}>{n}</Key>)}
        <Key onClick={back} testid={`${prefix}-backspace`} className="grid place-items-center text-white/70"><Delete className="h-5 w-5" /></Key>
        <Key onClick={() => press(0)} testid={`${prefix}-key-0`}>0</Key>
        <button type="button" onClick={() => onComplete(value)} disabled={loading || value.length < length} data-testid={submitTestid}
          className="h-14 rounded-2xl bg-gradient-to-br from-[#F55913] to-[#D9480F] text-white font-bold grid place-items-center shadow-lg shadow-orange-600/25 transition-[transform,opacity] duration-150 active:scale-95 disabled:opacity-35">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <ArrowRight className="h-5 w-5" />}
        </button>
      </div>
    </div>
  );
}
